import type { ReactNode } from "react";
import { cx } from "../cx";

/** A quiet placeholder for a list or panel with nothing in it yet. */
export function EmptyState({
  title,
  children,
  action,
  className = "",
}: {
  title: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      data-component="EmptyState"
      className={cx(
        "flex flex-col items-center gap-2 rounded-md border border-dashed border-line-strong bg-sunken px-6 py-10 text-center",
        className,
      )}
    >
      <p className="text-ui font-medium text-ink">{title}</p>
      {children ? <p className="max-w-md text-ui text-ink-2">{children}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
